import type { ReactNode, SVGProps } from "react";

export function BatchPaymentIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 12 16"
			width="12"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.02881 0.600098V3.71121C7.02881 3.91749 7.10406 4.11532 7.23802 4.26118C7.37197 4.40704 7.55365 4.48899 7.74309 4.48899H10.6002"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M9.17153 14.6001H2.02867C1.64979 14.6001 1.28643 14.4362 1.01852 14.1445C0.750607 13.8528 0.600098 13.4571 0.600098 13.0445V2.15565C0.600098 1.74309 0.750607 1.34743 1.01852 1.05571C1.28643 0.763986 1.64979 0.600098 2.02867 0.600098H7.02867L10.6001 4.48899V13.0445C10.6001 13.4571 10.4496 13.8528 10.1817 14.1445C9.91377 14.4362 9.55041 14.6001 9.17153 14.6001Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M5.6001 6.82227V11.4889"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M3.81445 8.76671L5.60017 6.82227L7.38588 8.76671"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
